import { SITE_NAME } from '../../../../../../config/environment';

const adaptData = ({ data, searchQuery }) => {
    const descriptionMeta = {
        name: 'description',
        content: `Terms and Conditions - ${SITE_NAME}`
    };

    return {
        title: `Terms and Conditions - ${SITE_NAME}`,
        meta: [descriptionMeta]
    }
}

export default adaptData;
